module.exports = [{
      plugin: require('/github/workspace/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
